import {Link} from "react-router-dom";

export default function HelpArticlesInternet() {
    return (
        <div className="selfcare-page-content selfcare-page-content--wide">
            <div className="selfcare-page-summary">
                <h2 className="heading heading--medium">Kom godt i gang med dit internet</h2>
                <p>Tjek vores guides og få det meste ud af dit internet.</p>
            </div>
            <div className="selfcare-help-articles">
                <Link to="/hjaelp/udstyr/installationsmanual">
                    Sådan installerer du din router
                </Link>
                <Link to="/hjaelp/internet-og-wifi/placering-af-router">
                    Sådan placerer du din router bedst
                </Link>
                <Link to="/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi">
                    Skift navn og kode på dit wifi
                </Link>
                <Link to="/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr">
                    Sådan bruger du din egen router
                </Link>
            </div>
        </div>
    )
}
